export default ({ app }) => {
  // check if user logged in or not
  if (typeof app.$sentry !== 'undefined') {
    console.log('app.$sentry', app.$sentry)
    const myInfo = app.store.getters['user/myInfo']
    app.$sentry.configureScope((scope) => {
      scope.setTag('samyan-coop-version', process.env.VERSION)
      scope.setTag('samyan-coop-app-platform', 'WEBSITE')
      if (myInfo) {
        scope.setUser({
          id: myInfo.Id,
          email: myInfo.Email
        })
      }
    })
  }
}
